import classNames from "classnames";

export const ArrowIcon = ({
  size = 10,
  color = "currentColor",
  className = "",
}) => (
  <svg
    viewBox="0 0 8 5"
    fill="none"
    width={size}
    height={size}
    className={classNames("noline", className)}>
    <path
      d="M7.369 0H.199l3.585 4.2L7.369 0z"
      fill={color}
      className="noline"></path>
  </svg>
);

export const RefreshIcon = ({
  size = 15,
  color = "currentColor",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    width={size}
    height={size}
    className={classNames("noline", className)}>
    <path
      d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
      fill={color}
      className="noline"
    />
  </svg>
);

export const ChevronIcon = ({ size = 10, color = "currentColor" }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    className="noline">
    <path
      d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
      fill={color}
      className="noline"></path>
  </svg>
);

export const ShareIcon = ({
  size = 24,
  color = "currentColor",
  className = "",
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 -960 960 960" 
    width={size}
    height={size}
    fill={color}
    className={classNames("noline", className)}>
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h120v80H240v400h480v-400H600v-80h120q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm200-240v-447l-64 64-56-57 160-160 160 160-56 57-64-64v447h-80Z"/>
  </svg>
);

export const LiveTV = ({
  size = 24,
  color = "currentColor",
  className = "",
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 -960 960 960" 
    width={size}
    height={size}
    fill={color}
    className={classNames("noline", className)}>
      <path d="m380-300 280-180-280-180v360ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"/>
  </svg>
);

export const LiveTVV2 = ({
  size = 24,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 12"
    width={size}
    height={size}
    className={className}
  >
    <rect
      x="0.879"
      y="0.5"
      width="16.121"
      height="10"
      rx="0.5"
      stroke="#E84D4D"
      fill="none"
      strokeWidth="1"
    />
    <path
      fill="red"
      d="M5.542 7h-.744V3.201h.744V7zm.752-3.435c0-.243.136-.364.406-.364s.405.121.405.364a.356.356 0 01-.103.27c-.066.064-.167.096-.302.096-.27 0-.406-.122-.406-.366zM7.071 7h-.745V4.27h.745V7zm1.433 0l-1.04-2.73h.779l.527 1.556c.059.197.095.383.11.559h.015c.008-.156.044-.343.11-.56l.524-1.554h.78L9.268 7h-.765zm3.328-2.251a.47.47 0 00-.372.151c-.09.1-.14.241-.153.425h1.045c-.004-.184-.052-.325-.145-.425a.486.486 0 00-.376-.151zm.104 2.3c-.439 0-.782-.121-1.03-.364-.247-.242-.37-.586-.37-1.03 0-.458.113-.81.341-1.06.23-.25.546-.376.95-.376.385 0 .686.11.9.33.215.22.323.523.323.91v.362h-1.76c.008.211.07.377.188.495.117.12.281.179.493.179a2.047 2.047 0 00.925-.215v.576c-.13.065-.27.113-.418.144a2.569 2.569 0 01-.541.049zM4.407 12h9.064v1H4.407z"
    />
  </svg>
);

export const Monitoring = ({
  size = 24,
  color = "currentColor",
  className = "",
}) => (
  <svg
  xmlns="http://www.w3.org/2000/svg" 
  viewBox="0 -960 960 960" 
  width={size}
  height={size}
  fill={color}
  className={classNames("noline", className)}>
    <path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z"/>
  </svg>
);

export const Clock = ({
  size = 24,
  color = "currentColor",
  className = "",
  style = {}
}) => (
  <svg
  xmlns="http://www.w3.org/2000/svg" 
  viewBox="0 -960 960 960" 
  width={size}
  height={size}
  fill={color}
  style={style}
  className={classNames("noline", className)}>
    <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"/>
  </svg>
);